export default __webpack_public_path__ + "static/media/logo-header.2e916cfe.svg";